import React from 'react';
import SVGLoader from './SVGLoader';

const defaults = {
  width: 16,
  height: 16,
  viewboxWidth: 12,
  viewboxHeight: 12,
};

export const KeywordsIcon = ({
  width = defaults.width,
  height = defaults.height,
  viewboxWidth = defaults.viewboxWidth,
  viewboxHeight = defaults.viewboxHeight,
  ...rest
}) => {
  return (
    <SVGLoader
      width={width}
      height={height}
      viewboxWidth={viewboxWidth}
      viewboxHeight={viewboxHeight}
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.8884 2.12495L6.38011 3.60975C6.23133 3.75619 5.99013 3.75619 5.84141 3.60975L4.33311 2.12495C4.18435 1.97851 4.18435 1.74107 4.33311 1.59462L5.84141 0.109835C5.99013 -0.0366117 6.23133 -0.0366117 6.38011 0.109835L7.8884 1.59462C8.03717 1.74107 8.03717 1.97851 7.8884 2.12495ZM11.3545 4.57222C11.5649 4.57222 11.7354 4.74012 11.7354 4.94722V7.05263C11.7354 7.25973 11.5649 7.42762 11.3545 7.42762H9.16809C8.95772 7.42762 8.78717 7.25973 8.78717 7.05263V4.94722C8.78717 4.74012 8.95772 4.57222 9.16809 4.57222H11.3545ZM10.2262 0.35617C10.362 0.353848 10.4887 0.422762 10.5588 0.537083L11.9453 2.79439C12.0164 2.9102 12.0187 3.05475 11.9512 3.17264C11.8836 3.29052 11.7568 3.36343 11.6194 3.36343H8.95304C8.81795 3.36343 8.69295 3.29298 8.62456 3.17828C8.55611 3.06358 8.55457 2.9218 8.62039 2.80566L9.90024 0.54835C9.96637 0.4317 10.0905 0.358492 10.2262 0.35617ZM4.45397 5.98816C4.45397 5.08738 5.19577 4.35713 6.11081 4.35713C7.0259 4.35713 7.76772 5.08738 7.76772 5.98816C7.76772 6.889 7.0259 7.61927 6.11081 7.61927C5.19577 7.61927 4.45397 6.889 4.45397 5.98816ZM8.25228 9.60985L7.6631 9.02985C7.61545 8.98294 7.55086 8.95659 7.4835 8.95659H4.32849C3.99124 8.12658 3.20428 7.57322 2.24871 7.57322C1.01208 7.57322 0.000289917 8.56925 0.000289917 9.78661C0.000289917 11.004 1.01208 12 2.24871 12C3.20428 12 3.99124 11.4467 4.32849 10.6166H7.4835C7.55086 10.6166 7.61545 10.5903 7.6631 10.5434L8.25228 9.96341C8.35145 9.86579 8.35145 9.70748 8.25228 9.60985ZM1.26199 10.2801C1.53882 10.2801 1.76324 10.0592 1.76324 9.78666C1.76324 9.51416 1.53882 9.29323 1.26199 9.29323C0.985157 9.29323 0.760739 9.51416 0.760739 9.78666C0.760739 10.0592 0.985157 10.2801 1.26199 10.2801Z"
      />
    </SVGLoader>
  );
};

export default KeywordsIcon;
